var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_13461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.855 0C4.86 0 0 4.86 0 10.855C0 15.9456 3.50486 20.2172 8.23287 21.3904V14.1723H5.99457V10.855H8.23287V9.42561C8.23287 5.73101 9.90497 4.01852 13.5323 4.01852C14.22 4.01852 15.4067 4.15356 15.8922 4.28816V7.29499C15.636 7.26807 15.1909 7.25461 14.6382 7.25461C12.8584 7.25461 12.1706 7.92893 12.1706 9.68179V10.855H15.7163L15.1071 14.1723H12.1706V21.6305C17.5456 20.9814 21.7104 16.4049 21.7104 10.855C21.71 4.86 16.85 0 10.855 0Z",
    fill: "#E2EEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_13461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.71,
    height: 21.71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.75e75cfc043afa5fa2b766c5d9af9817.svg";
export { ForwardRef as ReactComponent };